<template>
    <vx-card title="Supplier Return Reversal">
        <div class="flex vx-input-group">
            <vs-tabs v-if="render" v-model="$route.params.order">
                <vs-tab label="Waiting Approval">
                    <tab tab="Reversal"></tab>
                </vs-tab>
                <vs-tab label="Approved">
                    <tab tab="Approved"></tab>
                </vs-tab>
                <vs-tab label="Rejected">
                    <tab tab="Rejected"></tab>
                </vs-tab>
            </vs-tabs>
        </div>
    </vx-card>
</template>

<script>
import Tab from "./components/Tab.vue";

export default {
    components: {
        Tab,
    },
    data() {
        return {
            activeTab: "Reversal",
            render: true,
        }
    },
    methods: {

    }
}
</script>
